import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import greenhouseImage from './images/greenhouse.png';
import { farms } from '../components/List_farms';
import { fetchCurrentWeatherData, fetchHouseSituation } from './api';  // api.js から関数をインポート  

const Container = styled.div`  
  display: flex;  
  flex-direction: column;  
  padding: 0 20px 60px 20px;  
  background: #fafafa;  
  width: 100%;  
  margin: auto;  
  font-family: Arial, sans-serif;  
  box-sizing: border-box;  
  justify-content: flex-start;  
  align-items: stretch;  
  min-height: 100vh;  
`;

const CardContainer = styled.div`  
  display: flex;  
  flex-direction: column;  
  gap: 20px;  
  width: 100%;  
  margin: 0 auto;  
  box-sizing: border-box;  
`;

const Card = styled(Link)`  
  display: flex;  
  align-items: center;  
  justify-content: space-between;  
  background-color: ${props => props.error ? '#dcdcdc' : '#ffffff'}; // ここを修正 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);  
  border-radius: 15px;  
  padding: 15px;  
  color: #333333;  
  text-decoration: none;  
  transition: transform 0.2s;  
  height: 100px;  
  
  &:hover {  
    transform: scale(1.02);  
  }  
`;

const Img = styled.img`  
  border-radius: 10px;  
  width: 100px;  
  height: 100px;  
  object-fit: contain;  
  margin-right: 20px;  
`;

const CardDetails = styled.div`  
  flex: 1;  
  display: flex;  
  flex-direction: column;  
  justify-content: center;  
`;

const H3 = styled.h3`  
  font-size: 18px;  
  font-weight: bold;  
  margin: 0;  
  color: green;  
`;

const P = styled.p`  
  font-size: 12px;  
  color: #666666;  
  margin: 0;  
  font-weight: bold;  
`;

const Arrow = styled.div`  
  font-size: 24px;  
  margin-left: 20px;  
  color: green;  
  font-weight: bold;  
`;

const PlusButton = styled(Link)`  
  display: flex;  
  align-items: center;  
  justify-content: center;  
  width: 100%;  
  height: 60px;  
  background-color: #008000;  
  color: white;  
  font-size: 24px;  
  font-weight: bold;  
  border: none;  
  border-radius: 15px;  
  cursor: pointer;  
  transition: background-color 0.2s;  
  text-decoration: none;  
  text-align: center;  
  
  &:hover {  
    background-color: #006400;  
  }  
`;

const FarmList = () => {
  const [farmData, setFarmData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const dataPromises = farms.map(async (farm) => {
        try {
          const data = await fetchHouseSituation(farm.greenhouse);
          const weatherData = await fetchCurrentWeatherData(farm.location, farm.lat, farm.lon);
          return {
            ...farm,
            apiData: data,
            weatherData: weatherData,
          };
        } catch (error) {
          console.error(`Error fetching data for greenhouse ${farm.greenhouse}:`, error);
          return {
            ...farm,
            apiData: null,
            weatherData: null,
          };
        }
      });

      const results = await Promise.all(dataPromises);
      setFarmData(results);
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Container>
      <h2 style={{ color: '#333333', fontSize: '24px', fontWeight: 'bold' }}>
        Aiハウス
      </h2>
      <CardContainer>
        {farmData.map((farm) => (
          <Card
            to={`/farm/${farm.greenhouse}`}
            key={farm.greenhouse}
            error={!farm.apiData || !farm.weatherData} // ここを追加  
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Img src={greenhouseImage} alt="Greenhouse" />
              <CardDetails>
                <H3>{farm.name}</H3>
                <P>作物: {farm.jpkinds}</P>
                {farm.weatherData && (
                  <>
                    <P>天気: {farm.weatherData.phrase}</P>
                    <P>外気温: {farm.weatherData.temperature.value}°C</P>
                  </>
                )}
                <P>場所: {farm.location}</P>
              </CardDetails>
            </div>
            <Arrow>＞</Arrow>
          </Card>
        ))}
        {!loading && (
          <PlusButton to="/add-new-farm">農地を探す</PlusButton>
        )}
      </CardContainer>
    </Container>
  );
};

export default FarmList;  
